import React, { useEffect, useState } from 'react';
import { Alert, Box, Collapse, FormControl, Grid, IconButton, InputLabel, MenuItem, Select, Snackbar, Stack, TextField, Tooltip, Typography } from '@mui/material';
import { MdiIcon, Table } from '@components';
import { DropzoneArea } from 'mui-file-dropzone';
import { useFormik } from 'formik';
import * as yup from 'yup';
import { mdiChevronUp, mdiContentSave, mdiFileAccount, mdiMagnify, mdiPencil, mdiPlus } from '@mdi/js';
import moment from 'moment';
import { InfoDialog } from './infoDialog';
import { useModal } from 'mui-modal-provider';
import { v4 } from 'uuid';
import historicoAlteracoes from './history/handleHistory';
const DocumentosAssociados = ({ $state, CrmService, user, userId, client, cotacao, sendFileToParent, readOnly }) => {
    const [openSnackBar, setOpenSnackBar] = useState(false);
    const [snackBarMessage, setSnackBarMessage] = useState('');
    const [data, setData] = useState(); // dados dos documetnos
    const [loading, setLoading] = useState(true);
    const [refetching, setRefetching] = useState(false);
    const [error, setError] = useState(false);
    const [filter, setFilter] = useState([]); // filtros a aplicar na tabela
    const [sort, setSort] = useState([]); // ordenação da tabela
    const [options, setOptions] = useState({
        filter: [], // exemplo -> [{name: 'nome', type: 'TEXT'}, {name: 'ultimoContacto', type: 'DATE', options: {format: 'YYYY-MM-DD'}}, ...]
        sort: [] // exemplo -> ['id', 'nome', 'ultimoContacto', 'contactoTelefonico', 'nif', 'email', 'morada', 'localidade']
    });
    const [pagination, setPagination] = useState({
        pageIndex: 0,
        pageSize: 5
    });
    const tipoList = ['PDF', 'Fatura', 'Email', 'Relatório'];
    const [documento, setDocumento] = useState(null);
    const [documentoOriginal, setDocumentoOriginal] = useState(null);
    //const [editing, setEditing] = useState<boolean>(false);
    const [expand, setExpand] = useState(false);
    const [anexo, setAnexo] = useState(null);
    const [newAnexo, setNewAnexo] = useState(null);
    const validationSchema = yup.object().shape({
        designacao: yup.string().required('Preenchimento obrigatório'),
        tipo: yup.string().required('Preenchimento obrigatório'),
        uuid: yup.string().required('Obrigatório adicionar um documento')
    });
    const { showModal } = useModal();
    const formik = useFormik({
        initialValues: documento ?? {
            id: 0,
            designacao: '',
            tipo: '',
            active: 1,
            tamanho: '',
            dataRegisto: '',
            dataEdit: null,
            observacoes: '',
            idCoreContacto: cotacao?.contactoId ?? 0,
            idCoreCliente: cotacao?.clienteId ?? 0,
            funcionarioId: userId,
            uuid: ''
        },
        validationSchema: validationSchema,
        validateOnChange: false,
        onSubmit: async (values) => {
            let hist = null;
            if (cotacao) {
                // doc cotação
                values.cotacaoId = cotacao.id;
                values.idCoreContacto = cotacao.contactoId;
                values.idCoreCliente = cotacao.clienteId;
                hist = await handleHistory(values, documentoOriginal);
            }
            else if (user) {
                // doc coreContacto
                values.idCoreCliente = user.clienteId;
                values.idCoreContacto = user.id;
            }
            else if (client) {
                values.idCoreCliente = client;
            }
            // handle history
            if (values.observacoes == '') {
                values.observacoes = null;
            }
            submit(values, hist);
        }
    });
    const handleHistory = async (doc, docOriginal) => {
        let fields = [];
        //console.log(original);
        if (docOriginal === null || doc.id === 0) {
            fields = [{ field: 'designacao', name: 'Documento' }];
        }
        else {
            fields = [
                { field: 'designacao', name: 'Designação' },
                { field: 'tipo', name: 'Tipo' },
                { field: 'tamanho', name: 'Tamanho' },
                { field: 'observacoes', name: 'Observações' },
                { field: 'active', name: 'Documento: ' + doc.designacao } // Remover doc
            ];
        }
        try {
            // objeto original, objeto com alterações, campos a considerar, e ID user Logado, estadoId da cotação opcional
            const h = await historicoAlteracoes(docOriginal ?? documentoOriginal, doc, fields, userId, cotacao.estadoId);
            if (docOriginal !== null && doc.id !== 0) {
                if (doc.active !== 0) {
                    h.observacoes = `Alterações no Documento: \n"${doc.designacao}"\n ${h.observacoes}`;
                }
            }
            return h;
        }
        catch (error) {
            console.log(error);
        }
        return null;
    };
    const submit = async (newValues, hist) => {
        try {
            newValues.funcionarioId = await CrmService.getUserId();
        }
        catch (error) {
            console.log('Error ao obter id do colaborador', error);
        }
        const currentDate = moment().format();
        if (cotacao?.estadoId !== 10 && cotacao !== null) {
            if (newValues.uuid) {
                handleFile(newValues, hist);
            }
            try {
                if (newValues.dataRegisto == '') {
                    newValues.dataRegisto = currentDate;
                }
                else {
                    newValues.dataEdit = currentDate;
                }
                //const p = await CrmService.upsertDocumentoAssociado(newValues);
                await CrmService.upsertDoc(newValues, hist);
                setRefetching(true);
                fetchData();
            }
            catch (error) {
                console.log(error);
            }
        }
        else {
            if (data.data.find(doc => doc.uuid === newValues.uuid)) {
                setData(prevData => ({
                    ...prevData,
                    data: prevData.data.map(doc => (doc.uuid === newValues.uuid ? { ...doc, ...newValues, dataEdit: currentDate } : doc))
                }));
            }
            else {
                newValues.dataRegisto = currentDate;
                setData(prevData => ({
                    ...prevData,
                    data: prevData?.data ? [newValues, ...prevData.data] : [newValues]
                }));
            }
            handleFile(newValues, hist);
        }
        setExpand(false);
        setSnackBarMessage('Documento adicionado com sucesso!');
        setOpenSnackBar(true);
        formik.resetForm({
            values: {
                id: 0,
                designacao: '',
                tipo: '',
                tamanho: '',
                active: 1,
                dataRegisto: '',
                idCoreContacto: 0,
                idCoreCliente: 0,
                observacoes: '',
                funcionarioId: 0,
                uuid: ''
            }
        });
    };
    // Filtragem dentro de cada coluna
    // Modo de filtro (igual a, contém, começa com... )
    const getType = (type) => {
        switch (type) {
            case 'contains':
                return '$ilike';
            case 'startsWith':
                return '$sw';
            case 'notEquals':
                return '$not';
            case 'empty':
                return '$null';
            case 'notEmpty':
                return '$notNull';
            case 'greaterThan':
                return '$gt';
            case 'greaterThanOrEqualTo':
                return '$gte';
            case 'lessThan':
                return '$lt';
            case 'lessThanOrEqualTo':
                return '$lte';
            default:
                return '$eq';
        }
    };
    const initialFetch = async () => {
        if (loading) {
            // opt -> vai buscar os campos filtraveis
            const opt = await CrmService.optionsDocumentosAssociados();
            setOptions(opt);
            setLoading(false);
        }
    };
    const fetchData = async () => {
        setError(false);
        try {
            let filters = {};
            filter.forEach(r => {
                filters[r.id] = `${getType(r.type)}:${r.value}`;
            });
            let sorter = [];
            sort.forEach(r => {
                sorter.push(`${r.id}:${r.desc ? 'DESC' : 'ASC'}`);
            });
            if (cotacao === null) {
                filters['cotacaoId'] = `$eq:${-1}`;
            }
            if (cotacao?.id !== undefined) {
                filters['cotacaoId'] = `$eq:${cotacao?.id}`;
            }
            else if (client !== undefined) {
                filters['idCoreCliente'] = `$eq:${client}`;
            }
            else if (user !== undefined) {
                filters['idCoreContacto'] = `$eq:${user.id}`;
            }
            const aux = await CrmService.findAllDocumentosAssociados({
                limit: pagination.pageSize,
                page: pagination.pageIndex + 1,
                filter: filters,
                sortBy: sorter
            });
            // Update URL
            $state.go($state.current.name, {
                limit: pagination.pageSize,
                page: pagination.pageIndex + 1,
                sortBy: sorter,
                filter: Object.keys(filter).length > 0 ? JSON.stringify(filters) : undefined
            }, {
                notify: false,
                reload: false,
                location: 'replace',
                inherit: true
            });
            setData(aux);
        }
        catch (e) {
            console.log(e);
            setError(true);
        }
        setRefetching(false);
    };
    useEffect(() => {
        initialFetch();
        if (!refetching) {
            setRefetching(true);
            fetchData();
        }
    }, [pagination, filter, sort]);
    const handleTextInput = (event) => {
        const { id, value } = event.target;
        formik.setFieldValue(id, value);
    };
    const handleSnackBarClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenSnackBar(false);
    };
    const handleChange = (event) => {
        formik.setFieldValue('tipo', event.target.value);
    };
    const handleFile = async (values, hist) => {
        const formData = new FormData();
        if (newAnexo.file) {
            const newFileName = values.uuid ? values.uuid : newAnexo.file.name;
            formData.append('file', newAnexo.file, newFileName);
            // Se a imagem for igual, não realiza upload
            if (newAnexo.dummy) {
                return values;
            }
            else {
                // Atualiza o valor da imagem no objeto `values`
                values.uuid = newFileName;
                // no caso de ser doc da cotação, se estiver no primeiro estado, envia o file para registar após criar a cotação
                if (cotacao === null) {
                    sendFileToParent(values, newAnexo.file); // Guardou na BD e não no servidor (não devia guardar na BD)
                }
                else if (cotacao?.estadoId === 10) {
                    sendFileToParent(values, newAnexo.file);
                }
                else {
                    //sendFileToParent(values, newAnexo.file);
                    try {
                        // Upload da nova imagem
                        const response = await fetch('/api/Upload/crm/upload', {
                            method: 'POST',
                            body: formData
                        });
                        if (response.ok) {
                            const content = await response.json();
                            return content.result;
                        }
                        else {
                            console.log(response);
                            console.error('Erro ao adicionar ficheiro');
                        }
                    }
                    catch (error) {
                        console.error('Error uploading file:', error);
                    }
                }
            }
        }
        else {
            return values;
        }
    };
    // Localization for Dropzone messages
    const codePt = {
        'file-invalid-type': 'Tipo de ficheiro não permitido',
        'file-too-large': 'Ficheiro demasiado grande',
        'file-too-small': 'Ficheiro demasiado pequeno',
        'too-many-files': 'Demasiados ficheiros'
    };
    return (<Box>
      <Stack direction='column'>
        <Stack direction='row' justifyContent='flex-start' alignItems='center'>
          <Typography variant='h6' sx={{ color: 'black' }}>
            Documentos associados
          </Typography>

          {!readOnly ? (<Box>
              {expand ? (<Tooltip title={'Cancelar'}>
                  <IconButton color='primary' onClick={() => setExpand(!expand)}>
                    <MdiIcon path={mdiChevronUp} sx={{ color: '#1976D2' }}/>
                  </IconButton>
                </Tooltip>) : (<Box></Box>)}
              <Tooltip title={'Adicionar Documento'}>
                <IconButton color='primary' onClick={() => {
                if (expand) {
                    formik.handleSubmit();
                }
                else {
                    setAnexo(null);
                    setNewAnexo(null);
                    formik.resetForm();
                    setExpand(!expand);
                }
            }}>
                  <MdiIcon path={!expand ? mdiPlus : mdiContentSave} sx={{ color: '#1976D2' }}></MdiIcon>
                </IconButton>
              </Tooltip>
            </Box>) : (<></>)}
        </Stack>
      </Stack>

      <Collapse in={expand}>
        <Grid container spacing={2}>
          <Grid item xs={8}>
            <Grid container spacing={2}>
              <Grid item xs={6}>
                <TextField fullWidth id='designacao' label='Designação' color='info' size='small' onChange={handleTextInput} value={formik.values.designacao} error={formik.touched.designacao && Boolean(formik.errors.designacao)} helperText={formik.touched.designacao && formik.errors.designacao} required={true}/>
              </Grid>
              <Grid item xs={3}>
                <FormControl fullWidth size='small' sx={{
            '& .MuiOutlinedInput-root': {
                borderRadius: '4px'
            }
        }}>
                  <InputLabel id='demo-simple-select-label' color='info' required error={formik.touched.tipo && Boolean(formik.errors.tipo)}>
                    Tipo
                  </InputLabel>
                  <Select labelId='demo-simple-select-label' id='demo-simple-select' label='Tipo ' value={formik.values.tipo} onChange={handleChange} color='info' error={formik.touched.tipo && Boolean(formik.errors.tipo)}>
                    {tipoList.map((item, index) => (<MenuItem value={item} key={index}>
                        {item}
                      </MenuItem>))}
                  </Select>
                </FormControl>
              </Grid>

              <Grid item xs={3}>
                <TextField fullWidth id='tamanho' label='Tamanho' color='info' size='small' multiline={true} maxRows={3} onChange={handleTextInput} value={formik.values.tamanho} error={formik.touched.tamanho && Boolean(formik.errors.tamanho)} helperText={formik.touched.tamanho && formik.errors.tamanho} disabled/>
              </Grid>

              <Grid item xs={12}>
                <TextField fullWidth id='observacoes' label='Observações' color='info' size='small' multiline={true} rows={3} onChange={handleTextInput} value={formik.values.observacoes} error={formik.touched.observacoes && Boolean(formik.errors.observacoes)} helperText={formik.touched.observacoes && formik.errors.observacoes}/>
              </Grid>
            </Grid>
          </Grid>

          <Grid item xs={4}>
            <DropzoneArea maxFileSize={50 * 1024 * 1024} 
    // Override classical styling behavior because Chrome always puts dragging on invalid
    classes={{ invalid: 'dzNoRed' }} key={expand ? 'dropzone-open' : 'dropzone-closed'} acceptedFiles={[
            'image/jpeg',
            '.jpg',
            '.jpeg',
            'image/png',
            '.png',
            'application/pdf',
            '.pdf',
            'application/vnd.ms-outlook',
            '.msg', // .msg Outlook
            'application/msword',
            '.doc', // .doc
            'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
            '.docx', // .docx
            'application/vnd.ms-excel',
            '.xls', // .xls
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            '.xlsx', // .xlsx
            'text/csv',
            '.csv', // .csv
            'message/rfc822',
            '.eml' // .eml
        ]} filesLimit={1} initialFiles={anexo ? [anexo] : []} 
    //initialFiles={anexo ? [new File([], formik.values.designacao || (typeof anexo === 'string' ? anexo.split('/').pop() || 'documento' : 'documento'))] : []}
    onChange={files => {
            if (files.length > 0) {
                let t = files.pop();
                const fileExtension = `.${t.name.split('.').pop()}`; // Obtém a extensão do ficheiro
                const fileNameWithoutExtension = t.name.replace(fileExtension, ''); // Nome sem extensão
                // Calcula o tamanho do ficheiro
                const fileSizeInMB = t.size / (1024 * 1024); // Tamanho em MB
                const fileSizeDisplay = fileSizeInMB >= 1 ? `${fileSizeInMB.toFixed(2)} MB` : `${(t.size / 1024).toFixed(2)} KB`; // Exibe em KB se for menor que 1 MB
                let f = new File([t], `${v4()}.${t.name.split('.').pop()}`, { type: t.type });
                setNewAnexo({ file: f, dummy: false });
                setAnexo(URL.createObjectURL(f));
                formik.setFieldValue('uuid', f.name);
                formik.setFieldValue('tamanho', fileSizeDisplay);
                if (formik.values.designacao == '') {
                    formik.setFieldValue('designacao', fileNameWithoutExtension);
                }
                if (fileExtension == '.pdf') {
                    formik.setFieldValue('tipo', 'PDF');
                }
            }
            else {
                formik.setFieldValue('anexo', null);
                setNewAnexo(null);
                setAnexo(null);
            }
        }} showFileNamesInPreview={true} showAlerts={true} alertSnackbarProps={{
            anchorOrigin: { vertical: 'bottom', horizontal: 'center' },
            autoHideDuration: 2500
        }} useChipsForPreview={true} dropzoneText='Arraste e solte o documento aqui ou clique' getFileAddedMessage={file => `Adicionado: ${file}`} getFileRemovedMessage={file => `Removido: ${file}`} getFileLimitExceedMessage={limit => `Apenas ${limit} ficheiro(s) permitido(s)`} getDropRejectMessage={(file, accepts, max) => {
            // 1) size check
            if (typeof max === 'number' && file.size > max) {
                const mb = (bytes) => (bytes / (1024 * 1024)).toFixed(2);
                return `Ficheiro demasiado grande (${mb(file.size)} MB). Limite: ${mb(max)} MB.`;
            }
            // 2) type check (rough match against accept list)
            const mime = file.type || '';
            const ext = file.name.includes('.') ? '.' + file.name.split('.').pop() : '';
            const kind = mime || (ext ? `extensão ${ext}` : 'tipo desconhecido');
            return `Ficheiro rejeitado: ${file.name} (${kind})`;
        }}/>
            {formik.touched.uuid && formik.errors.uuid && (<Typography variant='caption' color='error'>
                {formik.errors.uuid}
              </Typography>)}
          </Grid>
        </Grid>
      </Collapse>

      <Box sx={{
            mt: 1,
            borderRadius: '15px',
            border: '1px solid #e0e0e0',
            overflow: 'hidden',
            boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)'
        }}>
        <Table storageKey={$state.current.name} data={data} columns={[
            ...(client !== undefined
                ? [
                    {
                        accessorKey: 'CoreContacto.nome',
                        header: 'Contacto',
                        size: 150,
                        Cell: ({ row }) => row.original?.CoreContacto?.nome ?? row.original?.CoreCliente?.nome
                    }
                ]
                : []),
            {
                accessorKey: 'designacao',
                header: 'Designação',
                size: 200
            },
            {
                accessorKey: 'tipo',
                header: 'Tipo',
                size: 100
            },
            {
                accessorKey: 'dataRegisto',
                header: 'Data',
                size: 100,
                Cell: ({ row }) => (moment(row.original.dataRegisto).isValid() ? moment(row.original.dataRegisto).format('DD/MM/YYYY') : 'N/D')
            },
            {
                accessorKey: 'tamanho',
                header: 'Tamanho',
                size: 100,
                muiTableBodyCellProps: {
                    align: 'right'
                },
                Cell: ({ renderedCellValue, row }) => (row.original.tamanho ? row.original.tamanho.toString().replace('.', ',') : 'N/D')
            }
        ]} initial={{
            sort: sort,
            filter: filter
        }} isLoading={refetching} options={options} onPaginate={setPagination} onFilter={setFilter} onSort={setSort} rowActionSize={150} actionItems={({ row }) => [
            <Box key={`actions-${row.original.id}`} display='flex' gap={1} sx={readOnly ? { ml: 3 } : {}}>
              {readOnly ? (<></>) : (<Tooltip title={'Editar dados'} placement='left'>
                  <IconButton color='primary' onClick={() => {
                        formik.setValues(row.original);
                        setDocumento(row.original);
                        setDocumentoOriginal(row.original);
                        if (row.original.uuid) {
                            let fileUrl = `/api/Upload/crm/download/${row.original.uuid}`;
                            setAnexo(fileUrl);
                        }
                        else {
                            setAnexo(null);
                        }
                        formik.setTouched({}, false);
                        if (!expand)
                            setExpand(true);
                    }}>
                    <MdiIcon path={mdiPencil} sx={{ color: '#1976D2' }}/>
                  </IconButton>
                </Tooltip>)}

              <Tooltip title={'Ver documento'} placement='top'>
                <IconButton color='primary' onClick={() => {
                    window.open(`/api/Upload/crm/download/${row.original.uuid}`, '_blank');
                }}>
                  <MdiIcon path={mdiFileAccount} sx={{ color: '#1976D2' }}/>
                </IconButton>
              </Tooltip>

              <Tooltip title={'Ver detalhes'} placement='top'>
                <IconButton color='secondary' onClick={() => {
                    const showData = [
                        { key: 'Designação', value: row.original.designacao },
                        { key: 'Colaborador', value: row.original.Funcionario.name },
                        { key: 'Tipo', value: row.original.tipo },
                        { key: 'Data de registo', value: moment(row.original.dataRegisto).format('DD-MM-YYYY') },
                        { key: 'Tamanho', value: row.original.tamanho },
                        { key: 'Ficheiro', value: row.original.uuid },
                        { key: 'Observações', value: row.original.observacoes }
                    ];
                    if (row.original.dataEdit != null) {
                        showData.splice(4, 0, { key: 'Data de edição', value: moment(row.original.dataEdit).format('DD-MM-YYYY') });
                    }
                    showModal(InfoDialog, {
                        title: 'Detalhes documento',
                        data: showData
                    });
                }}>
                  <MdiIcon path={mdiMagnify} sx={{ color: '#1976D2' }}/>
                </IconButton>
              </Tooltip>
            </Box>
        ]}></Table>
      </Box>
      <Snackbar open={openSnackBar} autoHideDuration={4000} anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }} onClose={handleSnackBarClose}>
        <Alert onClose={handleSnackBarClose} severity='success' variant='filled' sx={{ width: '100%' }}>
          {snackBarMessage}
        </Alert>
      </Snackbar>
    </Box>);
};
export default DocumentosAssociados;
